<template lang="pug">
div
    mixin discount(item, itemKey, discountLineItems)
        div(v-if="multipleDiscountLineItems")
            .row
                div(v-for="(discount, key) in item.applied_discounts")
                    .col-xs-11.p-l-sm
                        small {{ discount.discount.name }}
                    .col-xs-1.p-r-sm(v-if="key === 0")
                        small.pull-right x{{ discount.discount.quantity }}

            // cstore
            div(v-if="item.item_type === 'cstore'")
                .row
                    .col-xs-5
                        small {{ item.name }}
                    .col-xs-2
                        small.pull-right @{{ item.net_amount.toFixed(2) }}
                    .col-xs-2
                        small.pull-right x{{ item.quantity }}
                    .col-xs-3
                        small.pull-right {{ item.total_amount.toFixed(2) }}
                    div(v-if="discountTotal(item.applied_discounts) !== '0.00'")
                        .row
                            .col-xs-7
                                small.pull-right (Discount @{{ discountTotal(item.applied_discounts) }})
                        .row
                            .col-xs-7
                                small.pull-right (Normal Price: @{{ item.unit_price.toFixed(2) }})

            // fuel
            div(v-else)
                .row
                    .col-xs-5
                        small {{ item.name }} (Pump {{ item.fuel_details.pump_id }})
                    .col-xs-2
                        small.pull-right {{ discountFuelPrice(item) }}
                    .col-xs-5
                        small.pull-right {{ item.net_amount.toFixed(2) }}
                .row
                    .col-xs-5
                        small {{ item.quantity.toFixed(3) }} litre
                    .col-xs-2
                        small.pull-right PHP / L
                .row
                    .col-xs-7
                        small.pull-right (Discount @{{ discountTotal(item.applied_discounts) }})
                .row
                    .col-xs-7
                        small.pull-right (Normal Price: @{{ item.unit_price.toFixed(2) }})

    mixin discountV2(discount)
        div(v-if="!multipleDiscountLineItems")
            .row
                .col-xs-11.p-l-sm
                    small {{ discount.discountName }}
                .col-xs-1.p-r-sm
                    small.pull-right x{{ discount.discountQuantity }}

            .row(v-for="lineItem in discount.groupLineItems")
                .col-xs-5
                    small {{ lineItem.productName }}
                .col-xs-2
                    small.pull-right @{{ lineItem.netAmount.toFixed(2) }}
                .col-xs-2
                    small.pull-right x{{ lineItem.quantity }}
                .col-xs-3
                    small.pull-right {{ lineItem.netAmount.toFixed(2) }}
                .row
                    .col-xs-7
                        small.pull-right (Discount @{{ lineItem.totalDiscount.toFixed(2) }})
                .row
                    .col-xs-7
                        small.pull-right (Normal Price: @{{ lineItem.unitPrice.toFixed(2) }})

    mixin fuel(fuel)
        .row(v-if="fuel")
            .col-xs-5
                small {{ fuel.name }} (Pump {{ fuel.fuel_details.pump_id }})
            .col-xs-2
                small.pull-right {{ fuel.unit_price.toFixed(3) }}
            .col-xs-5
                small.pull-right {{ fuel.amount.toFixed(2) }}
        .row
            .col-xs-5
                small {{ fuel.quantity.toFixed(3) }} litre
            .col-xs-2
                small.pull-right PHP / L

    mixin product(product)
        .row(v-if="product")
            .col-xs-5
                small {{ product.name }}
            .col-xs-2
                small.pull-right @{{ product.unit_price.toFixed(2) }}&nbsp;
            .col-xs-2
                small.pull-right x{{ product.quantity }}
            .col-xs-3
                small.pull-right {{ product.amount.toFixed(2) }}

    .row(v-if="cancelProducts.length")
        .col-xs-12
            small.block.text-center.m-b-sm Cancelled Items

            div(v-for="product in cancelProducts")
                +product(product)

    .row(v-if="discountLineItems.length || products.length || fuels.length")
        .col-xs-12
            div(v-if="isSale || isVoid")
                small.block.text-center.m-y-sm Purchased Item(s)

            div(v-else-if="isRefund")
                small.block.text-center.m-y-sm Refunded Item(s)

            div(v-for="fuel in fuels")
                +fuel(fuel)

            div(v-for="(item, itemKey) in discountLineItems" v-if="!isRefund")
                +discount(item, itemKey, discountLineItems)

            div(v-for="discount in groupDiscounts" v-if="!isRefund")
                +discountV2(discount)

            hr(v-if="discountLineItems.length && products.length")

            div(v-for="product in products")
                +product(product)
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import StoreMixin from './store-mixin';
import { mapGetters } from 'vuex';
import Unleash from '@js/plugins/unleash';

export default {
    mixins: [receiptMixin, StoreMixin],
    computed: {
        ...mapGetters('transactionPostgres', [
            'discountLineItems',
            'multipleDiscountLineItems',
            'products',
            'fuels',
            'cancelProducts',
            'isSale',
            'isRefund',
            'isVoid',
            'groupDiscounts',
        ]),
    },

    methods: {
        discountTotal(discounts) {
            return discounts
                .map(d => {
                    return parseFloat(d.applied_amount);
                })
                .reduce((a, b) => a + b, 0)
                .toFixed(2);
        },

        discountFuelPrice(item) {
            return (item.net_amount / item.quantity).toFixed(3);
        },

        shouldShowDiscount(discountLineItems, itemKey, discount) {
            if (itemKey === 0) {
                let d = discountLineItems[itemKey].applied_discounts.filter(
                    appliedDiscount => {
                        return (
                            discount.discount_id === appliedDiscount.discount_id
                        );
                    },
                );

                console.log(d);

                if (d.length) {
                    return true;
                }
            }

            return false;
        },
    },
};
</script>

<style lang="scss" scoped>
.voided {
    font-size: 14px;
    vertical-align: middle;
}
.grand-total-amount {
    border: 1px solid #666;
    border-radius: 5px;
    margin-left: 0;
    margin-right: 0;
}
</style>
